import { defineStore } from 'pinia'
import { reactive  } from 'vue'
import { resetRouter } from '@/router'
import { useStorage } from '@vueuse/core'
import { login as apiLogin, logout as apiLogout } from '@/api/login/login'
import { usePermissionStore } from './permission'  // 添加这行导入
import { useShopStore } from './shopms'
import { ElMessage } from 'element-plus'

export const useUserStore = defineStore('user', () => {
  const token = useStorage('token', '')
  // 用户数据
  const user = reactive({
    username: useStorage('user-username', ''),
    nickname: useStorage('user-nickname', ''),
    avatar_url: useStorage('user-avatar', ''),
    menus: useStorage('user-menus', []),
    rule: useStorage('user-rule', []),
    permission: useStorage('permission',[]),
    adminmenu: useStorage('admin-menu',[]),
    systemid: useStorage('systemid',2),
  })

  // 方法：直接声明函数
  const setadmin = (value) => {
    user.systemid = value
  }

  // 登录API
  function login(data) {
    return new Promise((resolve, reject) => {
      apiLogin(data)
        .then((res) => {
          if(res.code == 1){
            token.value = res.data.token
            user.nickname = res.data.nickname
            user.menus = res.data.menus
            user.rule = res.data.rule
            user.permission = res.data.permission
            user.avatar_url = res.data.avatar
            user.adminmenu = res.data.adminmenu
            user.systemid = res.data.systemid
            resolve(res.data.rule)
          }else{
            reject(res);
          }
        })
    })
  }
  
  // 退出登录（改进版）
  function logout() {
    return new Promise((resolve) => {
      apiLogout()
        .then(res => {
          clearUserData()
          resolve(res)
        })
        .catch(err => {
          resolve(err)
        })
    })
  }

  // 清除用户数据
  function clearUserData() {
    token.value = ''
    user.menus = []
    user.rule = []
    user.username = ''
    user.adminmenu = []
    // 重置权限路由
    const permissionStore = usePermissionStore()
    permissionStore.resetRoutes()
    const shopStoresa = useShopStore()
    shopStoresa.shopId = 0;
    // 重置路由
    resetRouter()
    ElMessage({
      type:'success',
      message:`已退出登录`,
      duration:500,
      onClose: () => {  // 移除了 res 参数
        window.location.href = '/login';
      }
    })
  }

  // 重置token
  function resetToken() {
    clearUserData()
  }

  return {
    token,
    user,
    login,
    logout,
    resetToken,
    setadmin,
  }
})